import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 p-3 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "col-md-12 mb-20 p-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_4 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_5 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_6 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_7 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_8 = {
  key: 0,
  class: "badge rounded-pill fs-13 text-bg-danger"
}
const _hoisted_9 = {
  key: 1,
  class: "badge rounded-pill fs-13 text-bg-info"
}
const _hoisted_10 = {
  key: 2,
  class: "badge rounded-pill fs-13 text-bg-success"
}
const _hoisted_11 = {
  key: 6,
  class: "dropdown"
}
const _hoisted_12 = { class: "dropdown-menu" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 3 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 7 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.auth.can('ADD_BP_Z'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "btn btn-primary",
            to: { name: 'NewPaymentZonePage' },
            style: {"margin-right":"12px"}
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Ajouter Bon pour Zone ", -1)
            ])),
            _: 1,
            __: [0]
          }))
        : _createCommentVNode("", true)
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_vue_good_table, {
      columns: _ctx.columns,
      rows: _ctx.rows,
      responsive: "",
      "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Bons Sélectionés',
          disableSelectInfo: true,
        },
      onOnSelectedRowsChange: _ctx.selectPays,
      onOnSelectAll: _ctx.onSelectAllPays
    }, {
      emptystate: _withCtx(() => [
        _createVNode(_component_center, null, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Aucune entrées correspondants trouvés", -1)
          ])),
          _: 1,
          __: [1]
        })
      ]),
      "table-row": _withCtx((props) => [
        (props.column.field === 'pay_z_ref')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createElementVNode("b", null, _toDisplayString(props.row.pay_z_ref), 1)
            ]))
          : (props.column.field === 'zone_name')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createTextVNode(_toDisplayString(props.row.zone_name), 1),
                _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(props.row.agency_name), 1)
              ]))
            : (props.column.field === 'created_at')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  (props.row.created_at != null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(props.row.by_name), 1)
                ]))
              : (props.column.field === 'paid_time')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    (props.row.paid_time != null)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.getDate(props.row.paid_time)), 1),
                          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1))
                        ], 64))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(props.row.paid_by_name), 1)
                  ]))
                : (props.column.field === 'total')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(props.row.total) + " DH ", 1))
                  : (props.column.field === 'statut')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        (props.row.statut == 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Nouveau "))
                          : (props.row.statut == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Enregistré "))
                            : (props.row.statut == 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Payé "))
                              : _createCommentVNode("", true)
                      ], 64))
                    : (props.column.field === 'action')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _cache[10] || (_cache[10] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_12, [
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, {
                                class: "dropdown-item",
                                to: {
                      path: `/edit_payments_zone/${props.row.id}/${props.row.pay_z_ref}`,
                    }
                              }, {
                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                  _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Détails ", -1)
                                ])),
                                _: 2,
                                __: [5]
                              }, 1032, ["to"])
                            ]),
                            (
                    props.row.statut == 0 &&
                    props.row.num_bns == 0 &&
                    _ctx.auth.can('BP_Z')
                  )
                              ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                                  _createElementVNode("button", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.RemoveNote(props.row))
                                  }, _cache[6] || (_cache[6] = [
                                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Supprimer ", -1)
                                  ]), 8, _hoisted_14)
                                ]))
                              : _createCommentVNode("", true),
                            (
                    props.row.statut == 0 &&
                    props.row.num_bns != 0 &&
                    _ctx.auth.can('BP_Z')
                  )
                              ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                                  _createElementVNode("button", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.SaveBon(props.row))
                                  }, _cache[7] || (_cache[7] = [
                                    _createElementVNode("i", { class: "flaticon-diskette lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Enregistrer ", -1)
                                  ]), 8, _hoisted_16)
                                ]))
                              : _createCommentVNode("", true),
                            (
                    props.row.statut == 1 &&
                    props.row.num_bns != 0 &&
                    _ctx.auth.can('BP_Z')
                  )
                              ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                                  _createElementVNode("button", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.OpenBon(props.row))
                                  }, _cache[8] || (_cache[8] = [
                                    _createElementVNode("i", { class: "flaticon-unlock lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Ouvrir ", -1)
                                  ]), 8, _hoisted_18)
                                ]))
                              : _createCommentVNode("", true),
                            (
                    props.row.statut == 1 &&
                    props.row.num_bns != 0 &&
                    _ctx.auth.can('BP_Z')
                  )
                              ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                                  _createElementVNode("button", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.BonPaid(props.row))
                                  }, _cache[9] || (_cache[9] = [
                                    _createElementVNode("i", { class: "flaticon-check lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Changer En Payé ", -1)
                                  ]), 8, _hoisted_20)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(props.formattedRow[props.column.field]), 1))
      ]),
      _: 1
    }, 8, ["columns", "rows", "onOnSelectedRowsChange", "onOnSelectAll"]),
    _createVNode(_component_PaginatorContent, {
      pagination: _ctx.users,
      offset: 9,
      onPaginate: _ctx.getRecords
    }, null, 8, ["pagination", "onPaginate"])
  ]))
}